export default {
	fixedLayout: false,
	hideLogoOnMobile: false,
	devtool: 'source-map'
}



// WEBPACK FOOTER //
// ./src/config/index.js